<template>
    <div>
        <el-breadcrumb separator="/" class="bread">
            <el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'roleManager' }">角色管理</el-breadcrumb-item>
            <el-breadcrumb-item>角色权限配置</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 操作-->
        <!-- 表格分页  default-expand-all  :default-expanded-keys="expanded_keys"-->
        <div class="block">

            <el-tree class="menutree"
                     ref="tree"
                     v-loading="loading"
                     element-loading-text="拼命加载中"
                     :data="data2"
                     :props="defaultProps"
                     node-key="id"
                     :default-checked-keys="checked"
                     show-checkbox
                     :default-expanded-keys="expanded_keys"
                     :check-strictly="check_strictly"
                     :expand-on-click-node="false"
                    @node-click="node_click">
            </el-tree>
        </div>

        <el-row>
            <el-col :span="24" style="text-align: center;margin-top: 10px">
                <div class="grid-content bg-purple-dark">
                    <el-button type="success" @click="save"  v-if="btn_0435">保存</el-button> <!--  v-bind:class="{clearBtn : btn_0435 }"-->
                    <el-button @click="clear">重置</el-button>
                    <el-button @click="back">返回</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<style>
    @import "../../../assets/css/button.css";
</style>
<script>
    /*import  Bootpage from "../page/Bootpage.vue"*/

    export  default{
        data(){
            return {
                data2: [],
                defaultProps: {
                    children: 'children',
                    label: 'name',
                },
                checked:[],
                list:[],
                resourceid:[],
                checkhalf0:[],
                checkhalf1:[],
                //参数设置
                loading:false,
                roleId :"",
                btn_0435:true,
                expanded_keys:["0","01","02","03","04","05"],

                check_strictly:false,
                default_checked_keys:[],
                isCache:true,
            }



        },
        created(){
//            if(){
//
//            }
            /*if(this.getcookie("tenant_id")!="000000"){

                this.updateBtnState("043");
            }*/
            var params=this.$route.params;
            this.roleId=params.roleId;
            //调用查询函数
            this.getconfig();

        },
        methods: {
            getData(){
                //数据请求
                this.loading = true
                this.$http.get(this.requetHost+'/sys/authotity/findeAuthorityTree')
                    .then(response => {
                            if (response.status === 200) {
                                this.data2 = response.body.tree;
                            }else{
                                this.$message({
                                    showClose: true,
                                    message: '树资源加载不正确',
                                    type: 'error'
                                });
                            }
                            this.loading = false;
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        }
                    )
            },
            getconfig(){
                this.checked.length=0,
                 this.checkhalf0.length=0;
                this.checkhalf0.length=0;
                    this.loading = true
                //异步请求
                this.$http.get(this.requetHost+"/sys/authotity/roleAuthorityFind",{params:{"roleId":this.roleId}})
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.list.length>0){

                                response.body.list.forEach((item) => {
                                    //

                                    //this.checked.push(item.authorityId);

                                    if(item.half=="1"){
                                        this.checkhalf1.push(item.authorityId);
                                       this.checked.push(item.authorityId);

                                    }else{
                                        this.checkhalf0.push(item.authorityId);
                                    }

                                })
                            }else{
                                this.isCache=false
                            }
                            console.log("半节点>>"+this.checkhalf0.length);
                            console.log("全节点>>"+this.checkhalf1.length);

                        }
                        this.getData();
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })

            },
            getHalfCheckedNodes(nodesVale) {
                const nodes = [];
                     nodesVale.forEach((child) => {
                         if (child.indeterminate) {
                             nodes.push(child.data);
                         }
                     })

                return nodes;
            },
            save() {
                debugger
                var checknodes = "";
                var halfchecknodes = "";
                let nodesDOM = this.$refs.tree.$el.querySelectorAll('.el-tree-node');
                let nodesVue = [].map.call(nodesDOM, node => node.__vue__);
                console.log("nodesVue"+nodesVue);


                let arr = nodesVue.filter(item => item.indeterminate == true )

                //var arr=this.getHalfCheckedNodes(nodesVue);

                console.log("arr"+arr);
                debugger
                var isNodeCache=true;
                // //判断节点是否有缓存
                console.log(this.isCache);
                console.log( this.$refs.tree);
               arr.forEach((item) => {
                    halfchecknodes += item.$vnode.key+",";
               })

                this.$refs.tree.getCheckedKeys().forEach((item) =>{
                    checknodes += item+",";
                })
                if( this.checkhalf0.length>0 && this.isCache==true && checknodes!=""){
                    debugger
                    if(arr.length<this.checkhalf0.length){


                        isNodeCache=false;
                    }
                }
                debugger
//                this.$refs.tree.getHalfCheckedKeys().forEach((item) =>{
//                    halfchecknodes += item+",";
//                })

               if(isNodeCache==false ){
                    this.checkhalf0.forEach((item)=>{
                        halfchecknodes+=item+",";
                    })
                }

               var params={authorityId:halfchecknodes+";"+checknodes,roleId:this.roleId};
                console.log(params);
                this.loading = true;
              // var params={authorityId:checknodes,roleId:this.roleId};
                this.$store.dispatch('roleAuthoritySave',params).then((data)=>{
                    if(data.res==true){
                        this.$message({showClose: true,message: '保存成功',type: 'success'});
                        this.getconfig();
                    }
                    else{
                        this.$message({showClose: true,message: '参数错误',type: 'error'});
                    }
                })
            },
            clear(){
                this.getconfig();
            },
            back(){
                this.$router.push({name:"roleManager"})
            },
            node_click(data,node,val){

             //   console.log(data+"\n"+node+"\n"+val);
            },
            updateBtnState(pid){
                var _this=this
                this.$store.dispatch("getButton",pid).then((res)=>{
                    var data=res.btnlist;
                    var flag=false;
//                    if(res.username!="admin"){
                        if(data.length>0) {
                            for (var i = 0; i < data.length; i++) {
                                var btnId="btn_"+data[i].resourceId;
                                if(btnId=="btn_0435"){//是否拥有0435权限
                                    flag=true;
                                }
                            }
                        }
                        if(flag==false){
                            _this.btn_0435=false;
                        }
//                    }


                })
            },
        },

        watch: {
            // 如果路由有变化，会再次执行该方法
            '$route': 'getconfig'
        }

    }

</script>
<style>
    .block{
        margin-top: 10px;
    }
</style>


// WEBPACK FOOTER //
// ConfigAuthority.vue?a1b58c4a